import { ITextGroup } from '../interfaces'

/**
 * A text group's flat string leaves.
 *
 * `ITextGroup` permits one nested level, because a few groups need it — see
 * that type — which makes every leaf `string | { [key: string]: string }` for
 * the type checker. The great majority of callers read only flat keys, and
 * threading a cast through each destructured name is noise; this narrows once,
 * in one named place, so the widening is greppable.
 *
 * It is a cast, not a check: a caller that reaches for a key whose value is
 * actually a nested group gets a string-typed object at runtime. Nothing does
 * that today, and the token list is the contract.
 */
const flatTexts = (group?: ITextGroup): Record<string, string> =>
  (group ?? {}) as Record<string, string>

export default flatTexts
